import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Representante } from 'src/app/models/cml/representante/representante';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';

@Injectable({
  providedIn: 'root'
})
export class RepresentanteService extends AbstractIdbaService {

  override model: Representante = new Representante();

  constructor(http: HttpClient) { 
    super(http);
    this.programName = "cml/representante/representante.p";
  }

}
